// src/services/mlnoService.js

import config from "../config/config";
import { EmailSuccess, EmailFailed } from "../components/popups/allPopup";



// Save MLNO comments (general purpose)
export const saveMLNOComments = async (payload) => {
  const response = await fetch(`${config["backend-url"]}/save_mlno_comments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to save MLNO comments");
  }

  return await response.json();
};

// Save with approved=false and send mail
export const sendMailToUser = async (requestId, formData, signature, uploadedSignature, setModalMessage, setIsEmailModalOpen, fetchMLNOData) => {
  try {
    const token = localStorage.getItem("token") || "";
    const userEmail = localStorage.getItem("userEmail") || "";

    const savePayload = {
      requestId,
      justification: formData.justification || "",
      mlnoConsideration: formData.MLNOCOnsideration,
      mlnoComments: formData.mlnoComments,
      signature: uploadedSignature || signature,
      approved: false,
    };

    const saveResponse = await fetch(`${config["backend-url"]}/save_mlno_comments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(savePayload),
    });

    if (!saveResponse.ok) throw new Error("Failed to save MLNO review before sending email");

    const mailPayload = { requestId, comment: formData.mlnoComments, userEmail };
    const mailResponse = await fetch(`${config["backend-url"]}/send_mlno_comment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(mailPayload),
    });

    if (!mailResponse.ok) throw new Error("Failed to send MLNO comment email");

    await fetchMLNOData(requestId);
    setModalMessage(<EmailSuccess />);
  } catch (error) {
    console.error("❌ sendMailToUser error:", error);
    setModalMessage(<EmailFailed />);
  } finally {
    setIsEmailModalOpen(true);
  }
};

// Save user consideration notes (accessible to all users, not just MLNO)
export const saveUserConsideration = async (payload) => {
  const response = await fetch(`${config["backend-url"]}/save_user_consideration`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to save user consideration");
  }

  return await response.json();
};

// Deactivate request and cleanup
export const deactivateRequestAndCleanup = async (requestId) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${config["backend-url"]}/deactivate_request_and_cleanup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ requestId }),
  });

  const result = await response.json();
  if (!response.ok) throw new Error(result.error || "Failed to deactivate request");
  return result;
};

// Init final review
export const initFinalReview = async (requestId, setStatuses, setCanFinalize, setRequiredDocumentsAttached, checkFinalizeAvailability, getLoadedDocKeys) => {
  try {
    const response = await fetch(`${config["backend-url"]}/get-all-statuses`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ request_id: requestId }),
    });

    if (response.ok) {
      const result = await response.json();
      setStatuses(result.statuses || {});
      const ready = checkFinalizeAvailability(result.statuses);
      setCanFinalize(ready);
    }

    const updatedDocsRaw = localStorage.getItem("updatedDocs-/FinalReview") || "{}";
    const updatedDocs = JSON.parse(updatedDocsRaw);
    const updatedKeys = Object.keys(updatedDocs).filter((key) => !key.startsWith("transaction-detail"));

    const loadedDocKeys = await getLoadedDocKeys();
    const allPresent = updatedKeys.every((key) => loadedDocKeys.includes(key));
    setRequiredDocumentsAttached(allPresent);
  } catch (err) {
    console.warn("⚠️ Error initializing final review:", err.message);
  }
};

// Unlock section
export const unlockSection = async (requestId, entityId, section, initFinalReviewCallback) => {
  try {
    const response = await fetch(`${config["backend-url"]}/unlock_section_status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({ requestId, entityId, section }),
    });

    if (!response.ok) throw new Error("Failed to unlock section");

    const data = await response.json();
    console.log("✅ Section unlocked:", data);
    initFinalReviewCallback(requestId);
  } catch (error) {
    console.error("❌ Error unlocking section:", error);
  }
};
